export interface Pagination {
    current_page: number;
    per_page: number;
    last_page: number;
    total: number;
}

export interface PaginatedResponse<T> {
    status: boolean
    data: T[]
    pagination: Pagination
}

export interface CreateResponse<T> {
    message: string
    data: T
}